import { notify } from '@kyvg/vue3-notification';
import { storeToRefs } from 'pinia';
import { useMapsStore } from '@/stores/maps-store';

export const useMap = () => {
  const { getNationalities } = useMapsStore();
  const { nationalities } = storeToRefs(useMapsStore());

  const handleGetNationalities = async () => {
    try {
      await getNationalities();
    } catch (error) {
      const errorMsg = error?.toString() ?? 'Unknown error!';
      notify({
        type: 'error',
        title: errorMsg,
      });
    }
  };

  return { handleGetNationalities, nationalities };
};
